import { render, staticRenderFns } from "./assignpermissions.vue?vue&type=template&id=f4775044&scoped=true"
import script from "./assignpermissions.vue?vue&type=script&lang=js"
export * from "./assignpermissions.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./assignpermissions.vue?vue&type=style&index=0&id=f4775044&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f4775044",
  null
  ,true
)

export default component.exports